import type { CurrentSubscription, LocalizedText, Package } from '../types';

export type PlanAction = 'current' | 'scheduled' | 'upgrade' | 'downgrade';

/**
 * `tier` is the server-computed plan rank (token amounts are never exposed to users).
 * Lower tier than the current plan = downgrade (scheduled at cycle end by the backend).
 */
export function getPlanAction(
  pkg: Package,
  current: CurrentSubscription | null,
  packages: Package[]
): PlanAction {
  if (current?.package?.publicId === pkg.publicId) {
    return 'current';
  }

  if (current?.scheduledChange?.packagePublicId === pkg.publicId) {
    return 'scheduled';
  }

  const currentTier = packages.find((item) => item.publicId === current?.package?.publicId)?.tier;
  if (currentTier === undefined || pkg.tier === undefined) {
    return 'upgrade';
  }

  return pkg.tier < currentTier ? 'downgrade' : 'upgrade';
}

export function pickLocalized(text: LocalizedText | undefined, language: string): string | null {
  const preferred = language.startsWith('vi') ? text?.vi : text?.en;
  const fallback = language.startsWith('vi') ? text?.en : text?.vi;
  const value = preferred?.trim() || fallback?.trim() || '';

  return value || null;
}

export function pickLocalizedList(
  list: { en: string[]; vi: string[] } | undefined,
  language: string
): string[] {
  const preferred = language.startsWith('vi') ? list?.vi : list?.en;
  const fallback = language.startsWith('vi') ? list?.en : list?.vi;
  const values = preferred && preferred.length > 0 ? preferred : (fallback ?? []);

  return values.map((item) => item.trim()).filter(Boolean);
}
